const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
};

const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const packSizeAPI = {
  fetchPackSizes: async () => {
    const response = await fetch(`${API_CONFIG.baseURL}/packs/sizes`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return handleResponse(response);
  },

  updatePackSizes: async (packSizesArray) => {
    const isValid = Array.isArray(packSizesArray) && 
                    packSizesArray.length > 0 &&
                    packSizesArray.every(val => Number.isInteger(val) && val > 0);
    
    if (isValid) {
      return { success: true, updatedSizes: packSizesArray };
    }
    throw new Error("Invalid pack sizes: must be positive integers");
  },

  rebuildPackSizes: async (packSizesArray) => {
    const response = await fetch(`${API_CONFIG.baseURL}/packs/rebuild`, {
      method: 'POST',
      body: JSON.stringify({ sizes: packSizesArray }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return handleResponse(response);
  },

  calculatePacks: async (itemsWanted) => {
    if (itemsWanted <= 0) return [];

    const response = await fetch(`${API_CONFIG.baseURL}/packs/calculate-order`, {
      method: 'POST',
      body: JSON.stringify({ items: itemsWanted }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await handleResponse(response);

    return Object.entries(data)
      .map(([pack, quantity]) => ({ pack, quantity }))
      .sort((a, b) => b.pack - a.pack);
  }
};
